import React from 'react';
import './header-notification-menu.scss';
import NotificationItem from '../../components/notification-item/notification-item';
import ContentMessage from '../../components/content-message/content-message';
import Env from 'Env';
import clsx from 'clsx';
import { markNotificationsRead } from '../../actions/notificationActions';
import { useSelector, useDispatch } from 'react-redux';

const HeaderNotification = ({ hasTopBar, isSearchActive, isImpersonating, isMaintenanceActive, onSelectNotificationItem }) => {
  const dispatch = useDispatch();

  const notificationState = useSelector((state) => state.notifications);
  const isAdminPortal = Env.isAdminPortal();

  const toggleAndSetContentModal = (item) => {
    if (!item.isRead) {
      dispatch(markNotificationsRead(item.id, true));
    }
    onSelectNotificationItem(item);
  };

  const buildRows = () => {
    const notifications = notificationState.notificationsList;

    if (notifications.length > 0) {
      return (
        <>
          {notifications.map((item) => (
            <NotificationItem
              toggleAndSetContentModal={toggleAndSetContentModal}
              notification={item}
              key={item.id}
            />
          ))}
        </>
      );
    } else {
      return (
        <div className="card-content-error-message">
          <ContentMessage message={'No notifications to view'} />
        </div>
      );
    }
  };

  return (
    <div>
      <div
        className={clsx(
          'notification-box',
          { 'notification-box--has-top-nav': hasTopBar },
          { 'notification-box--is-impersonating': isImpersonating && !isAdminPortal },
          { 'notification-box--is-maintenance-active': isMaintenanceActive && isAdminPortal },
          { 'notification-box--is-search-active': isSearchActive }
        )}
      >
        <ul className="notification-list">{buildRows()}</ul>
      </div>
    </div>
  );
};

export default HeaderNotification;
